import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default  function AddIcon(props:any) {
   
    return (

       <SvgIcon fontSize="small"  viewBox="0 0 16 16">

         <path d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z" fill="currentColor"/>

       </SvgIcon>
    )


}